import siteData from "../data/siteData.json";
import "./GalleryPage.css";
import Modal from "react-modal";
import { useState } from "react";

Modal.setAppElement("#root");

export default function GalleryPage() {
  const [selectedImg, setSelectedImg] = useState(null);

  return (
    <section className="gallery-page">
      <h2 className="gallery-page-title">Project Gallery</h2>

      {/* Card Grid */}
      <div className="gallery-grid">
        {siteData.galleryImages.map((item, index) => (
          <div
            className="gallery-card"
            key={index}
            onClick={() => setSelectedImg(item.image)}
          >
            <img src={item.image} alt="gallery" />
          </div>
        ))}
      </div>

      {/* Image Modal */}
      <Modal
        isOpen={!!selectedImg}
        onRequestClose={() => setSelectedImg(null)}
        overlayClassName="modal-overlay"
        className="modal-content"
      >
        <div className="modal-inner">
          <img src={selectedImg} alt="popup" className="modal-img" />
          <button className="close-btn" onClick={() => setSelectedImg(null)}>
            ✕
          </button>
        </div>
      </Modal>
    </section>
  );
}
